module.exports = __webpack_public_path__ + "assets/img/KeyReport_Focus.33112166.svg";